<template>
  <div id="payBtnBar">
    <h3 class="title">選擇付款方式</h3>
    <div class="pay-btn-bar">
        <router-link to="/pay/creditCard" @click.native="upName" class="pay-btn">
          <div class="box">
            <div class="icon">
              <img :src="pay1">
            </div>
            <div class="text">信用卡付款</div>
          </div>
        </router-link>
        <router-link to="/pay/web" @click.native="upName2" class="pay-btn">
          <div class="box">
            <div class="icon">
              <img :src="pay2">
            </div>
            <div class="text">WebATM付款</div>
          </div>
        </router-link>
        <router-link to="/pay/pay711" @click.native="upName3" class="pay-btn">
          <div class="box">
            <div class="icon">
              <img :src="pay3">
            </div>
            <div class="text">超商代碼付款</div>
          </div>
        </router-link>
    </div>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.title{
  margin-top: 16px;
  width: 100%;
  font-size: 22px;
  font-weight: 700;
  color: $secondary-color;
  text-align: left;
}
.pay-btn-bar{
  width: 100%;
  height: 160px;
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  .pay-btn{
    width: 290px;
    height: 130px;
    border: 2px solid $secondary-color;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    &.router-link-exact-active{
      background-color: $primary-color;
      border-color: $primary-color;
      .text{
        color: $light-color;
      }
    }
    &:hover{
      background-color: $primary-color;
      border-color: $primary-color;
    }
    .box{
      position: absolute;
      width: 200px;
      // height: 100px;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%)
    }
    .icon{
      height: 70px;
      img{
        height: 100%;
      }
    }
    .text{
      color: $secondary-color;
      font-size: 16px;
      font-weight: 700;
      width: 100%;
      text-align: center;
    }
    &:hover .text{
      color: $light-color;
    }
  }
}

//**************media*********************************************************************
@media screen and (max-width:415px){
  .title{
    margin-top: 24px;
    font-size: 14px;
    text-align: center;
  }
  .pay-btn-bar{
    height: 110px;
    margin-top: 20px;
    padding: 0 15px;
    .pay-btn{
      width: 90px;
      height: 90px;
      border-radius: 10px;
      .box{
        width: 100%;
        height: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%)
      }
      .icon{
        height: 40px;
        img{
          height: 100%;
        }
      }
      .text{
        font-size: 12px;
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>

<script>
import pay1 from "../assets/icon_PayByCard-01.svg"
import pay2 from "../assets/icon_PayByATM-01.svg"
import pay3 from "../assets/icon_PayByShop-01.svg"

export default {
  name: 'payBtnBar',
  data: function () {
      return {
          pay1: pay1,
          pay2: pay2,
          pay3: pay3
      }
  },
  methods:{
      upName(){
      this.$store.commit('set_name',{til:'付款完成！',cont:'感謝您的訂購，我們將盡快為您處理您的訂單:)'})
      },
      upName2(){
      this.$store.commit('set_name',{til:'訂單成立！',cont:'請於兩天內完成匯款，逾期店家將有權取消訂單。'})
      },
      upName3(){
      this.$store.commit('set_name',{til:'訂單成立！',cont:'請於兩天內至超商完成付款，逾期將會自動取消訂單'})
      }
  }
}
</script>

